import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  setOpenNotificationMenu,
  setPreviousQuestionId,
  setSelectedcompany,
  setSelectedSiteId,
  setShowmapmodal
} from "../redux/actions/actions";
import store from "../redux/store/store";
import { notificationApi } from "../notificationApi";
import { navigateToChatPage, navigateToClientChatPage } from "../common/Helper";

let infoToastCallCount = 0;

export const showSuccessToast = (message) =>
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });

export const showErrorToast = (message) =>
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });

export const showInfoToast = (message, payload, navigate, dispatch, loginData) => {
  infoToastCallCount++;

  // ✅ Defer toast rendering to avoid setState during render
  setTimeout(() => {
    toast.info(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      onClick: () => {
        handleNotificationClick(payload, infoToastCallCount, navigate, dispatch, loginData);
      }
    });
  }, 0);
};

export const handleNotificationClick = (item, toastId, navigate, dispatch, loginData) => {
  const currentLoginData = store.getState()?.main?.loginData || loginData;
  if (item !== undefined) {
    const url = item["gcm.n.link"] || item?.link || "";

    const parseURL = (urlString) => {
      if (!urlString) return { screenName: "", matchId: "", clientId: "" };
      const urlWithoutProtocol = urlString.replace("mybuilderid://", "");
      const screenNameMatch = urlWithoutProtocol.match(/screenName=([^&]+)/);
      const idMatch = urlWithoutProtocol.match(/id=([^&]+)/);
      const clientIdMatch = urlWithoutProtocol.match(/ClientId=([^&]+)/);

      return {
        screenName: screenNameMatch ? screenNameMatch[1] : "",
        matchId: idMatch ? idMatch[1] : "",
        clientId: clientIdMatch ? clientIdMatch[1] : ""
      };
    };

    let { screenName, matchId, clientId } = parseURL(url);
    if (!screenName && item?.screenName) {
      screenName = item.screenName;
    }
    if (!screenName) {
      const titleLower = (item?.Title || item?.title || "").toLowerCase();
      if (titleLower.includes("daily") && (titleLower.includes("challenge") || titleLower.includes("builder"))) {
        screenName = "DailyChallenge";
      } else if (titleLower.includes("builderbucks") || titleLower.includes("builder bucks")) {
        screenName = "DailyChallenge";
      }
    }
    if (!screenName) return;

    if (screenName.includes("?")) {
      screenName = screenName.split("?")[0];
    }
    // ✅ Defer any state updates and navigation to avoid React warnings
    setTimeout(() => {
      notificationApi(Number(item?.NotificationMessageId), currentLoginData);
      switch (screenName) {
        case "DailyChallenge":
        case "DailyChallengeCard":
          navigate("/home", {
            state: {
              from: "from-notification",
              showDailyChallenge: true,
              openDailyChallengeModal: true,
              refresh: Date.now()
            }
          });
          break;
        case "DashboardNotifications":
          dispatch(setOpenNotificationMenu(true));
          break;
        case "Sites":
          navigate(`/sites`);
          break;
        case "Community":
          navigate(`/community`);
          break;
        case "Chat":
          navigate(`/chat`);
          break;
        case "Trades":
          navigate(`/trades`);
          break;
        case "Products":
          navigate(`/products`);
          break;
        case "Manufactures":
          navigate(`/manufactures`);
          break;
        case "Companies":
          navigate(`/companies`);
          break;
        case "BuilderNetwork":
          navigate(`/contacts`);
          break;
        case "Montage":
          navigate(`/montages`);
          break;
        case "ResumeBuilder":
          navigate(`/resume-builder`);
          break;
        case "Carpool":
          navigate(`/carpool`);
          break;
        case "JobPostings":
        case "JobPosting":
          const isExternal = url.includes("?External");
          navigate(`/job-postings`, {
            state: { jobId: matchId, isExternal: isExternal }
          });
          break;
        case "Expenses":
          navigate(`/expenses`);
          break;
        case "Timesheet":
          navigate(`/timesheets`);
          break;
        case "BuySell": //MODULE TO BE IMPLEMENTED,
          navigate(`/buy-sell`);
          break;
        // case "workbuddy": //MODULE TO BE IMPLEMENTED,
        //   navigate(`/work-buddy`);
        // break;
        case "RewardStore":
          dispatch(setPreviousQuestionId(Number(matchId)));
          navigate("/reward-store");
          break;
        case "CompanyInfo":
          navigate(`/company/${matchId}`);
          break;
        case "ManufacturerInfo":
          navigate(`/manufacturer/${matchId}`);
          break;
        case "ProductInfo":
          navigate(`/product/${matchId}`);
          break;
        case "TradeDetail":
          navigate(`/trade/${matchId}`);
          break;
        case "ProjectPage":
          navigate(`/project/${matchId}`);
          break;
        case "ConversationScreen":
          navigateToChatPage(navigate, dispatch, "notification", "", "", Number(matchId), "");
          break;
        case "ContactProfile":
          navigate(`/${matchId}`);
          break;
        case "DetailPost":
          navigate("/community", {
            state: { item: { custom1: Number(matchId) }, from: "from-notification", postRefresh: new Date().getTime() }
          });
          break;
        case "MapForSingleSite":
          dispatch(setSelectedSiteId(Number(matchId)));
          dispatch(setSelectedcompany());
          dispatch(
            setShowmapmodal({
              open: true,
              from: "dashboard",
              select: "site"
            })
          );
          break;
        case "Tickets":
          navigate("/tickets");
          dispatch(setOpenNotificationMenu(true));
          break;
        case "ProfileBoard":
          // navigate("/profile");
          navigate(`${currentLoginData?.userInformation?.UserId}`, {
            from: "NotificationsForProfile"
          })
          break;
        case "MyExperience":
          // navigate("/profile", {
          //   from: "NotificationsForProfile"
          // });
          navigate(`${currentLoginData?.userInformation?.UserId}`, {
            from: "NotificationsForProfile"
          })
          break;
        case "DashboardNotifications":
          navigate("/home", {
            from: "DashboardNotificationsForNotify"
          });
          break;
        case "Quiz":
          dispatch(setPreviousQuestionId(Number(matchId)));
          navigate("/reward-store/earn-builderbucks/earn-rewards");
          break;
        case 'ClientConversationScreen':
          navigateToClientChatPage(navigate, Number(clientId), Number(matchId));
          break;
        default:
          navigate("/home");
          break;
      }
    }, 0);
  }
};
